export const timeStringToMinutes = (str?: string): number | null => {
  if (!str) return null;

  const match = str.match(/(\d+):(\d+)(am|pm)?/i);
  if (!match) return null;

  let [_, hh, mm, ap] = match;
  let h = parseInt(hh, 10);
  let m = parseInt(mm, 10);

  // Handle 24-hour HH:mm coming from formatDate
  if (!ap) {
    return h * 60 + m;
  }

  ap = ap.toLowerCase();
  if (ap === "pm" && h !== 12) h += 12;
  if (ap === "am" && h === 12) h = 0;

  return h * 60 + m;
};

export const toDate = (value?: string): Date | null => {
  if (!value) return null;
  const d = new Date(value);
  return isNaN(d.getTime()) ? null : d;
};

export const isValidISODate = (value?: string): boolean => {
  if (!value) return false;

  // Accept yyyy-mm-dd and ISO datetimes such as yyyy-mm-ddTHH:mm:ss.sssZ
  const datePart = value.trim().match(/^(\d{4}-\d{2}-\d{2})/)?.[1] ?? value.trim();
  const [year, month, day] = datePart.split('-').map(Number);

  if (!year || !month || !day) return false;
  if (month < 1 || month > 12) return false;

  const maxDaysInMonth = new Date(year, month, 0).getDate();
  if (day < 1 || day > maxDaysInMonth) return false;

  return true;
};

export const toDateOnly = (value?: string | null): string => {
  if (!value?.trim()) return '';
  const datePart = value.trim().match(/^(\d{4}-\d{2}-\d{2})/)?.[1];
  return datePart && isValidISODate(datePart) ? datePart : '';
};

export const hhmmToAmPm = (hhmm: string) => {
  const [hhStr, mmStr] = hhmm.split(':');
  const hh = Number(hhStr);
  const mm = Number(mmStr);

  if (!Number.isFinite(hh) || !Number.isFinite(mm)) return hhmm;

  const ap = hh >= 12 ? 'PM' : 'AM';
  const h12 = ((hh + 11) % 12) + 1;

  return `${String(h12).padStart(2, '0')}:${String(mm).padStart(2, '0')} ${ap}`;
};
